export default function CrashFallback() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.75rem",
        fontFamily: "DM Sans, sans-serif",
        color: "#0C2624",
        padding: "2rem",
        textAlign: "center",
      }}
    >
      <h2 style={{ margin: 0, fontSize: "1.25rem", fontWeight: 700 }}>
        Something went wrong
      </h2>
      <p style={{ margin: 0, fontSize: "0.875rem", color: "#6b7280" }}>
        The error has been reported. Please refresh the page.
      </p>
      <button
        onClick={() => window.location.reload()}
        style={{
          marginTop: "0.5rem",
          padding: "0.5rem 1.5rem",
          borderRadius: "9999px",
          background: "#1E5E5B",
          color: "#fff",
          border: "none",
          cursor: "pointer",
          fontSize: "0.875rem",
          fontFamily: "inherit",
        }}
      >
        Refresh
      </button>
    </div>
  );
}
